// extracted by mini-css-extract-plugin
export var brand = "_8g-9";
export var compact = "_8g-6";
export var extraSmall = "_8g-7";
export var icon = "_8g-0";
export var large = "_8g-4";
export var light = "_8g-1";
export var medium = "_8g-5";
export var outline = "_8g-b";
export var primaryDark = "_8g-a";
export var primaryLight = "_8g-8";
export var primaryModern = "_8g-c";
export var success = "_8g-2";
export var successSolid = "_8g-3";